export enum GovernedDocumentApprovalState {
    Preparation = "preparation",
    Pending = "pending",
    Approved = "approved",
    Rejected = "rejected"
}
